import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { CompanyData } from '../../../types/company-data';

export abstract class CompanyDetailsTabBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getMyCompanyData(): Promise<CompanyData>;
  public abstract getManagedCompanyById(companyId: string): Promise<CompanyData>;
}
